import React, { Component, useEffect, useState } from 'react';
import * as firebase from 'firebase';

import './App.css';
import Home from './components/home';
import Login from "./components/login";
import SignUp from "./components/signUp";
import CreateCompany from "./components/newCompany";
import 'typeface-lato';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Sidebar from './components/sidebar';

import Dashboard from "./components/dashboard";
import Seek from "./components/seek";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import Appbar from './components/appbar';

const theme = createMuiTheme({
  typography: {
    fontFamily: 'lato'
  }
});
import { initApp } from './utils/firebase';

export default function App() {
  useEffect(() => {
    // initApp();
    setLoggedIn(!!firebase.auth().currentUser);
  }, []);

  useEffect((val) => {
    setLoggedIn(val);
  }, [loggedIn]);

  const [loggedIn, setLoggedIn] = useState(false);

  const handleLogout = () => {
    // localStorage.clear();
    firebase.auth().signOut();
    setLoggedIn(false);
  }

  return (
    <Router>
      < Appbar />
      <Grid container >
        <Grid item xs={12}>
          <div style={{ height: '100px', display: 'block' }}>

          </div>
        </Grid>
        <Grid item xs={2}>
          <Sidebar />
        </Grid>
        <Grid item xs={8}>
          <Switch>

            <Route path="/login">
              <Login setLoggedIn={setLoggedIn} />
            </Route>
            <Route path="/seekFunding">
              <Seek />
            </Route>
            <Route path="/new-company">
              <CreateCompany />
            </Route>
            <Route path="/signup">
              <SignUp setLoggedIn={setLoggedIn} />
            </Route>
            <Route path="/dashboard">
              <Dashboard />
            </Route>
            <Route path="/">
              <Home />
            </Route>

          </Switch>
        </Grid>

        <Grid item xs={2}>
          <List>
            <ListItem>
              <Link to="/">Home</Link>
            </ListItem>
            {loggedIn
              ? (<div>
                <ListItem>
                  <Link onClick={handleLogout} to="/">Logout</Link>
                </ListItem>

                <ListItem>
                  <Link to="/seekFunding">Seek Funding</Link>
                </ListItem>
              </div>
              )
              : (<div><ListItem>
                <Link to="/login">Login</Link>
              </ListItem>
                <ListItem>
                  <Link to="/signup">Sign Up</Link>
                </ListItem>
              </div>
              )}
          </List>
        </Grid>

      </Grid>
    </Router >
  );
}



// WEBPACK FOOTER //
// ./src/App.js